export const getRandomInt = (
  minimum: number = 0,
  maximum: number = 99
): number => {
  const min = Math.ceil(minimum)
  const max = Math.floor(maximum)

  return Math.floor(Math.random() * (max - min + 1)) + min
}
